import { useState } from "react";
import { Badge, Button, Drawer, Empty, Flex, Spin, Typography } from "antd";
import { neutral, semantic, spacing, typography } from "../../theme/tokens";

const { Text } = Typography;

/**
 * Khay thông báo (tách khỏi `HeaderConek`).
 *
 * Chỉ hiển thị cho `type_user === "CUSTOMER"`. Bấm vào một dòng thì mở rộng nội
 * dung và đánh dấu đã đọc cùng lúc.
 */
export default function NotificationDrawer({ open, onClose, notifications }) {
  const [expandedId, setExpandedId] = useState(null);
  const { items, loading, loadingMore, error, hasMore, loadMore, markRead, markAllRead } =
    notifications;

  const toggle = (item) => {
    if (expandedId === item.id) {
      setExpandedId(null);
      return;
    }
    setExpandedId(item.id);
    if (item.is_read === 0) markRead(item.id);
  };

  return (
    <Drawer title="Thông báo" onClose={onClose} open={open}>
      <Flex justify="space-between" align="center" style={{ marginBottom: spacing[4] }}>
        <Text strong>Tất cả</Text>
        <Button type="link" size="small" onClick={markAllRead} style={{ padding: 0 }}>
          Đánh dấu tất cả là đã đọc
        </Button>
      </Flex>

      {loading ? (
        <Flex justify="center" style={{ padding: spacing[6] }}>
          <Spin tip="Đang tải thông báo..." />
        </Flex>
      ) : error ? (
        <Text style={{ color: semantic.danger }}>{error}</Text>
      ) : items.length === 0 ? (
        <Empty description="Không có thông báo nào" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <>
          {items.map((item) => (
            <div
              key={item.id}
              onClick={() => toggle(item)}
              style={{
                cursor: "pointer",
                padding: `${spacing[3]}px ${spacing[2]}px`,
                borderBottom: `1px solid ${neutral[100]}`,
                background: item.is_read === 0 ? neutral[50] : "transparent",
              }}
            >
              <Flex align="center" gap={spacing[2]}>
                <Text strong style={{ color: semantic.info }}>
                  {item.title}
                </Text>
                {item.is_read === 0 && <Badge dot />}
              </Flex>

              {expandedId === item.id && (
                <Text
                  style={{
                    display: "block",
                    marginTop: spacing[1],
                    color: neutral[600],
                    fontSize: typography.size.base,
                  }}
                >
                  {item.message || "Không có mô tả"}
                </Text>
              )}

              <Text
                style={{
                  display: "block",
                  marginTop: spacing[1],
                  color: neutral[400],
                  fontSize: typography.size.sm,
                }}
              >
                {item.created_at ? new Date(item.created_at).toLocaleString("vi-VN") : ""}
              </Text>
            </div>
          ))}

          {hasMore && (
            <Button
              type="link"
              loading={loadingMore}
              onClick={loadMore}
              style={{ marginTop: spacing[3] }}
            >
              Xem thêm
            </Button>
          )}
          {!hasMore && items.length > 0 && (
            <Text
              style={{
                display: "block",
                marginTop: spacing[3],
                color: neutral[400],
                fontSize: typography.size.sm,
              }}
            >
              Đã tải hết thông báo.
            </Text>
          )}
        </>
      )}
    </Drawer>
  );
}
